// GENERATED FILE - DO NOT MODIFY
export enum TransactionType {
    PurchaseOrder = "P",
    InventoryProjectTransfer = "4",
    InventorySiteTransfer = "A",
    InventoryAdjustment = "3",
    MaterialReservation = "H",
    InternalSales = "B",
    ReceiptOfGoods = "2",
}

export let nameof = "TransactionType";
